import React from "react";
import { FaLock } from "react-icons/fa";
import GeneralMessage from "./GeneralMessage";

const AccessDenied = ({
  icon = <FaLock className="text-5xl text-red-500" />,
  title = "Access Denied",
  message = "You don't have the necessary permissions to access this area. If you " +
    "believe this is an error, please contact your system administrator.",
}) => {
  return <GeneralMessage icon={icon} message={message} title={title} />;
};

export default AccessDenied;
